import revive_payload_client_4sVQNw7RlN from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunkError_client_sI3VvI2fC5 from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/plugins/chunkError.client.ts";
import sentry_client_shVUlIjFLk from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/plugins/sentry.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunkError_client_sI3VvI2fC5,
  sentry_client_shVUlIjFLk
]